import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { iInitState, iProductListing } from '~/app/models';

interface iState extends iInitState {
  data: iProductListing;
  message: string;
  urlData: {
    pageSize: number;
    currentPage: number;
  };
  queryString: string;
  isDESC: boolean;
  keySearch: string;
  controller: null | AbortController;
  dataDetails: any | null;
  dataEdit: any | null;
}

const initialState: iState = {
  status: '',
  controller: null,
  data: { items: [], search_criteria: {}, total_count: 0 } as iProductListing,
  urlData: { pageSize: 10, currentPage: 1 },
  message: '',
  isDESC: false,
  keySearch: 'entity_id',
  queryString: '',
  dataDetails: null,
  dataEdit: null,
};

const customFormSlice = createSlice({
  name: 'REVIEW LIST',
  initialState,
  reducers: {
    // Synchronous Actions
    resetData: () => ({ ...initialState }),
    setQueryString: (state, action) => ({ ...state, queryString: action.payload }),

    setUrlData: (state, action) => ({ ...state, urlData: action.payload }),
    setIsDESC: (state, action) => ({ ...state, isDESC: action.payload }),
    setKeySearch: (state, action) => ({ ...state, keySearch: action.payload }),
    setDataDetails: (state, action: PayloadAction<any | null>) => ({ ...state, dataDetails: action.payload }),
    changeController: (state, action) => ({ ...state, controller: action.payload }),
    setDataEdit: (state, action: PayloadAction<any | null>) => ({ ...state, dataEdit: action.payload }),

    // Asynchronous Actions
    getDataFulfilled: (state, action) => ({ ...state, data: action.payload, status: 'fulfilled' }),
    getDataRejected: (state, action) => ({ ...state, status: 'rejected', message: action.payload }),
    getDataPending: (state) => ({ ...state, status: 'pending' }),
    resetQueryString: (state) => ({ ...state, queryString: '' }),
  },
});

export const { ...rest } = customFormSlice.actions;
const customFormReducer = customFormSlice.reducer;

export default customFormReducer;
